import { Pill, type PillSize, type PillVariant } from "@clipboard-health/ui-components";

import { SHIFT_AUCTION_LABEL } from "./constants";

interface ShiftAuctionPillProps {
  size?: PillSize;
  variant?: PillVariant;
}

export function ShiftAuctionPill(props: ShiftAuctionPillProps) {
  const { size = "small", variant = "filled" } = props;

  return (
    <Pill
      size={size}
      variant={variant}
      label={SHIFT_AUCTION_LABEL}
      iconType="bolt"
      backgroundColor={(theme) => theme.palette.shift?.urgent.background}
      color={(theme) => theme.palette.shift?.urgent.text}
      iconColor={(theme) => theme.palette.shift?.urgent.icon}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
